import Axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import * as jwtDecode from 'jwt-decode';
import { trim } from 'lodash';
import qs from 'qs';
import React from 'react';
import { put, retry, select } from 'redux-saga/effects';
import snakeCaseKeys from 'snakecase-keys';

import { toast } from 'react-toastify';
import { Creators as AuthActions } from '../ducks/auth';
import { Creators as UsuarioActions } from '../ducks/usuario';

import { OAuth, OAuthNewToken, legado } from '../../services/api';
import {
  USER_KEY,
  excludeData,
  getLocalObj,
  movcadUpt,
  persistData,
} from '../../services/auth';
import history from '../../services/history';

import { TipoPerfilUsuarioEnum } from '../../enums';

import { responseHandlerGet } from '../../utils/responseHandler';

import { toSnake } from '../../utils/toSnake';
import { isEmail } from '../../utils/validation';

import { Error } from '@unimed-fesp/components';
import { ErrorToast } from '../../components/molecules/Toast';

const { REACT_APP_MOVCAD_LEGACY } = process.env;

export function* signIn(action) {
  try {
    const { auth } = action.payload;

    const tokenData = jwtDecode(auth.access_token);
    const usuario = {
      idUsuarioLogado: tokenData.id_usuario_logado,
      login: tokenData.unique_name[0],
      nome: tokenData.given_name,
      role: tokenData.role,
      ...(tokenData.Contratante && {
        codigoContratante: tokenData.Contratante,
      }),
      ...(tokenData.NomeContratante && {
        nomeEmpresa: tokenData.NomeContratante,
      }),
      GrupoContratante: tokenData.GrupoContratante || 0,
    };

    if (usuario.role !== 'Adm') {
      yield put(
        UsuarioActions.getContratantesUsuarioRequest(usuario.idUsuarioLogado)
      );
    }
    // persistData(data);

    // Descomentar após finalização da tela de login
    // Request após login para atualizar sessão no movcad legado
    if (process.env.NODE_ENV !== 'development')
      yield put(UsuarioActions.postAtualizarSessaoLegadoRequest(auth));

    yield put(AuthActions.signInSuccess(auth, usuario));
  } catch (error) {
    yield put(AuthActions.signInError(error));
  }
}

export function* refreshInvalidToken(action) {
  try {
    const codigoContratante = yield select(
      (state) => state.auth.usuario.codigoContratante
    );
    const invalidToken = jwtDecode(action.payload.invalidToken.access_token);

    const requestBody = {
      ...(codigoContratante && { codigoContratante }),
      UserId: invalidToken.unique_name[0],
      password: invalidToken.Validate,
      GrantType: 'refresh_token',
      RefreshToken: action.payload.invalidToken.refresh_token,
      UserType: !isEmail(invalidToken.unique_name[0])
        ? TipoPerfilUsuarioEnum.returnNameForRefresh[invalidToken.role]
        : null,
    };

    const response = yield retry(1, 2000, OAuth.post, `/oauth`, requestBody);

    const isSuccess = response.status > 199 || response.status < 299;

    const tokenData = jwtDecode(response.data.access_token);

    if (isSuccess) {
      const usuario = {
        idUsuarioLogado: tokenData.id_usuario_logado,
        login: tokenData.unique_name[0],
        nome: tokenData.given_name,
        role: tokenData.role,
        ...(tokenData.Contratante && {
          codigoContratante: tokenData.Contratante,
        }),
        ...(tokenData.NomeContratante && {
          nomeEmpresa: tokenData.NomeContratante,
        }),
        GrupoContratante: tokenData.GrupoContratante || 0,
      };

      if (process.env.NODE_ENV !== 'development')
        yield put(
          UsuarioActions.postAtualizarSessaoLegadoRequest(response.data)
        );

      persistData(response.data);
      yield put(AuthActions.signInSuccess(response.data, usuario));
      // history.push('/novo/lista');
    }
  } catch (error) {
    // Axios.get(`${REACT_APP_MOVCAD_LEGACY}/LogOut.aspx/EfetuarLogOut`)
    //   .then(() => {
    //     // const { unsuccessResponse } = responseHandlerGet(
    //     //  error.response,
    //     //  '',
    //     //  'refreshInvalidToken',
    //     //  200
    //     // );
    //     // put(AuthActions.refreshInvalidTokenError(unsuccessResponse));
    //     excludeData();
    //   })
    //   .finally(() => {
    //     window.location.replace(`${REACT_APP_MOVCAD_LEGACY}/Login.aspx`);
    //   });
    // yield put(AuthActions.signOut());
  }
}

export function* getChangeToken(action) {
  const { queryParams } = action.payload;
  queryParams.id = trim(queryParams.id);

  try {
    const response = yield retry(
      5,
      2000,
      OAuthNewToken.get,
      `/oauth/token-contratante`,
      { params: queryParams }
    );

    if (response.status === 200) {
      persistData(response.data);
      movcadUpt();
      window.location.reload();
    }
  } catch (error) {
    yield put(AuthActions.getChangeTokenError(error));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para a troca de contratantes.
      </ErrorToast>
    );
  }
}

export function* postLogin(action) {
  try {
    const { usuarioParams } = action.payload;

    const queryUsuarioParams = snakeCaseKeys(usuarioParams);
    const response = yield retry(
      1,
      2000,
      OAuth.post,
      `/oauth`,
      queryUsuarioParams
    );

    const token = response.data;
    const tokenData = jwtDecode(token.access_token);

    const usuario = {
      idUsuarioLogado: tokenData.id_usuario_logado,
      login: tokenData.unique_name[0],
      nome: tokenData.given_name,
      role: tokenData.role,
      changePassword: tokenData.bt_alteracao_senha,
      ...(tokenData.Contratante && {
        codigoContratante: tokenData.Contratante,
      }),
      ...(tokenData.NomeContratante && {
        nomeEmpresa: tokenData.NomeContratante,
      }),
      GrupoContratante: tokenData.GrupoContratante || 0,
    };

    const { isSuccess } = responseHandlerGet(
      response,
      action.payload,
      'postLogin',
      200
    );
    if (usuario.changePassword === 'false') {
      persistData(token);
    }
    yield put(
      AuthActions.postLoginSuccess(
        response.data,
        usuario,
        isSuccess,
        usuario.changePassword
      )
    );
    yield put(UsuarioActions.postAtualizarSessaoLegadoRequest(token));

    // if (usuario.role !== 'Adm') {
    //   yield put(
    //     UsuarioActions.getContratantesUsuarioRequest(usuario.idUsuarioLogado)
    //   );
    // }
  } catch (error) {
    if (error.response.status === 406) {
      history.push('/novo/error', {
        error: 406,
        message: `Identificamos que a versão do sistema no cache do seu navegador está desatualizada. 
          Por gentileza, limpe o cache do seu navegador nas configurações dele.`,
        title: 'Versão do Sistema Desatualizada.',
        path: '/novo/',
      });
    }

    const { unsuccessResponse } = responseHandlerGet(
      error,
      error.response,
      'postLogin',
      200
    );

    yield put(AuthActions.postLoginError(unsuccessResponse, error.response));
  }
}

export function* postRecaptchaVerify(action) {
  const { queryParams } = action.payload;

  const params = qs.stringify(queryParams, {
    addQueryPrefix: true,
  });

  try {
    const response = yield retry(
      5,
      2000,
      OAuth.post,
      `/oauth/validar-captcha${params}`
    );

    const isSuccess = response.status === 200 || false;

    yield put(AuthActions.postRecaptchaVerifySuccess(response, isSuccess));
  } catch (error) {
    yield put(AuthActions.postRecaptchaVerifyError(error));
    toast.error(
      <ErrorToast size="30">
        Não foi possível realizar a conexão para validação de segurança do
        usuário.
      </ErrorToast>
    );
  }
}

export function* getRecuperarSenha(action) {
  const { params } = action.payload;

  try {
    const response = yield retry(1, 2000, OAuth.get, `/oauth/recuperar-senha`, {
      params,
    });

    const isSuccess = response.status === 204 || false;

    yield put(AuthActions.getRecuperarSenhaSuccess(response, isSuccess));
  } catch (error) {
    const errorStatusCode = error.response.status;
    yield put(AuthActions.getRecuperarSenhaError(error));
    // if (errorStatusCode !== 403) {
    //   toast.error(
    //     <ErrorToast size="30">
    //       Não foi possível realizar a conexão para envio de e-mail de
    //       redefinição de senha.
    //     </ErrorToast>
    //   );
    // }
  }
}

export function* postRecuperarSenha(action) {
  const { params } = action.payload;

  const queryUsuarioParams = snakeCaseKeys(params);

  try {
    const response = yield retry(
      5,
      2000,
      OAuth.post,
      `/oauth/recuperar-senha`,
      queryUsuarioParams
    );

    const isSuccess = !!(response.status === 200 || 204);

    yield put(AuthActions.postRecuperarSenhaSuccess(response, isSuccess));
  } catch (error) {
    yield put(AuthActions.postRecuperarSenhaError(error));
  }
}

export function* signOutLegado(action) {
  try {
    yield retry(1, 2000, legado.get, `/LogOut.aspx/EfetuarLogOut`);
  } catch (e) {
    console.log(e);
  } finally {
    if (getLocalObj(USER_KEY)) {
      excludeData();
      yield put(AuthActions.signOut());
    }
  }
}
